import { render, staticRenderFns } from "./TextFormRemark.vue?vue&type=template&id=7adc3e4a"
import script from "./TextFormRemark.vue?vue&type=script&lang=js"
export * from "./TextFormRemark.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports